import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { AppSettings } from '../../sharedcomponents/_common/constants/app.constants';
import { utilityService } from '../../sharedcomponents/commonservice/utility.service';
import { ReplaySubject } from 'rxjs/ReplaySubject';
//import {Repeatorder} from '../../models/Repeatorder/Repeatordermodal'
@Injectable()
export class RepeatorderService {
  //Store
  private transHistory = new ReplaySubject<any>();
  constructor(private http: Http,
    private utilserv: utilityService) { }
  // 1 Envolpe for

  getRepeatorderDashBoardlistservice() {
    return this.utilserv.soapPostwithoutAction(this.getRepeatorderDashBoardlistenvolpe(),
      AppSettings.transactionService);

  };
  getRepeatorderDashBoardlistenvolpe() {
    
    const envelope =
      `<s:Envelope xmlns:a="http://www.w3.org/2005/08/addressing" xmlns:s="http://www.w3.org/2003/05/soap-envelope">
        <s:Header>
          <a:Action s:mustUnderstand="1">http://tempuri.org/ITransactionService/GetOrderT2Based</a:Action>
          <a:MessageID>urn:uuid:a18cf285-47b2-4b96-a547-14b931af3c20</a:MessageID>
          <a:ReplyTo>
            <a:Address>http://www.w3.org/2005/08/addressing/anonymous</a:Address>
          </a:ReplyTo>
        </s:Header>
        <s:Body>
          <OrderRequest xmlns="http://tempuri.org/">
            <BenificiaryId i:nil="true" xmlns:i="http://www.w3.org/2001/XMLSchema-instance" />
            <LanguageCode>${sessionStorage.langCode}</LanguageCode>
            <OrderNo i:nil="true" xmlns:i="http://www.w3.org/2001/XMLSchema-instance" />
            <Session xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.OrderProcessing.Contracts.DataContracts.Soap" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
              <d4p1:T1 i:nil="true" />
              <d4p1:T2>${sessionStorage.T2}</d4p1:T2>
            </Session>
          </OrderRequest>
        </s:Body>
      </s:Envelope>
      `;
    return envelope;

  }

  getRepeatorderlistservice(reqObject) {
    return this.utilserv.soapPostwithoutAction(this.getRepeatorderlistenvolpe(reqObject),
      AppSettings.transactionService + '/GetOrder');

  };
  getRepeatorderlistenvolpe(reqObject) {

    const envelope = `<s:Envelope xmlns:a="http://www.w3.org/2005/08/addressing" xmlns:s="http://www.w3.org/2003/05/soap-envelope">
        <s:Header>
          <a:Action s:mustUnderstand="1">http://tempuri.org/ITransactionService/RepeatOrderT2Based</a:Action>
          <a:MessageID>urn:uuid:5de63b18-f183-4e86-92fd-f52ad94aa98b</a:MessageID>
          <a:ReplyTo>
            <a:Address>http://www.w3.org/2005/08/addressing/anonymous</a:Address>
          </a:ReplyTo>
        </s:Header>
        <s:Body>
          <OrderRequest xmlns="http://tempuri.org/">
            <BenificiaryId>${reqObject.BenificiaryId}</BenificiaryId>
            <LanguageCode>${sessionStorage.langCode}</LanguageCode>
            <OrderNo>${reqObject.OrderNo}</OrderNo>
            <Session xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.OrderProcessing.Contracts.DataContracts.Soap" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
            <d4p1:T1></d4p1:T1>
            <d4p1:T2>${sessionStorage.T2}</d4p1:T2>
            </Session>
          </OrderRequest>
        </s:Body>
      </s:Envelope>`;
    return envelope;

  }

  // ///Store Data
  setRepeatorderDataDashBoard(dataValues: any) {
    this.transHistory.next(dataValues);
  }

  // getRepeatorderData(): Observable<any> {
  //   return this.transHistory.asObservable();
  // }
}



// WEBPACK FOOTER //
// ./src/app/_services/repeatorder/repeatorder.service.ts